/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "common";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface TagSet {
}

export enum TagSet_Enum {
  UNKNOWN = 0,
  PROTO_SET_A = 1,
  PROTO_SET_B = 2,
  PROTO_SET_C = 3,
  PROTO_SET_D = 4,
  PROTO_SET_E = 5,
  QUAL1_SET_A = 6,
  QUAL1_SET_B = 7,
  QUAL1_SET_C = 8,
  QUAL1_SET_D = 9,
  QUAL1_SET_E = 10,
  QUAL1_SET_F = 11,
  UNRECOGNIZED = -1,
}

export function tagSet_EnumFromJSON(object: any): TagSet_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return TagSet_Enum.UNKNOWN;
    case 1:
    case "PROTO_SET_A":
      return TagSet_Enum.PROTO_SET_A;
    case 2:
    case "PROTO_SET_B":
      return TagSet_Enum.PROTO_SET_B;
    case 3:
    case "PROTO_SET_C":
      return TagSet_Enum.PROTO_SET_C;
    case 4:
    case "PROTO_SET_D":
      return TagSet_Enum.PROTO_SET_D;
    case 5:
    case "PROTO_SET_E":
      return TagSet_Enum.PROTO_SET_E;
    case 6:
    case "QUAL1_SET_A":
      return TagSet_Enum.QUAL1_SET_A;
    case 7:
    case "QUAL1_SET_B":
      return TagSet_Enum.QUAL1_SET_B;
    case 8:
    case "QUAL1_SET_C":
      return TagSet_Enum.QUAL1_SET_C;
    case 9:
    case "QUAL1_SET_D":
      return TagSet_Enum.QUAL1_SET_D;
    case 10:
    case "QUAL1_SET_E":
      return TagSet_Enum.QUAL1_SET_E;
    case 11:
    case "QUAL1_SET_F":
      return TagSet_Enum.QUAL1_SET_F;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TagSet_Enum.UNRECOGNIZED;
  }
}

export function tagSet_EnumToJSON(object: TagSet_Enum): string {
  switch (object) {
    case TagSet_Enum.UNKNOWN:
      return "UNKNOWN";
    case TagSet_Enum.PROTO_SET_A:
      return "PROTO_SET_A";
    case TagSet_Enum.PROTO_SET_B:
      return "PROTO_SET_B";
    case TagSet_Enum.PROTO_SET_C:
      return "PROTO_SET_C";
    case TagSet_Enum.PROTO_SET_D:
      return "PROTO_SET_D";
    case TagSet_Enum.PROTO_SET_E:
      return "PROTO_SET_E";
    case TagSet_Enum.QUAL1_SET_A:
      return "QUAL1_SET_A";
    case TagSet_Enum.QUAL1_SET_B:
      return "QUAL1_SET_B";
    case TagSet_Enum.QUAL1_SET_C:
      return "QUAL1_SET_C";
    case TagSet_Enum.QUAL1_SET_D:
      return "QUAL1_SET_D";
    case TagSet_Enum.QUAL1_SET_E:
      return "QUAL1_SET_E";
    case TagSet_Enum.QUAL1_SET_F:
      return "QUAL1_SET_F";
    case TagSet_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseTagSet(): TagSet {
  return {};
}

export const TagSet = {
  encode(_: TagSet, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TagSet {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTagSet();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): TagSet {
    return {};
  },

  toJSON(_: TagSet): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<TagSet>, I>>(base?: I): TagSet {
    return TagSet.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TagSet>, I>>(_: I): TagSet {
    const message = createBaseTagSet();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
